'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _followSeller = require('../../redux/modules/followSeller');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _FollowSellerButton = require('./FollowSellerButton');

var _FollowSellerButton2 = _interopRequireDefault(_FollowSellerButton);

var _FollowSellerLink = require('./FollowSellerLink');

var _FollowSellerLink2 = _interopRequireDefault(_FollowSellerLink);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FollowSellerContainer = (_dec = (0, _reactRedux.connect)(function (state, _ref) {
    var sellerId = _ref.sellerId;

    var followed = (0, _followSeller.isSellerFollowed)(state, sellerId);
    return {
        followed: followed
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        submitFollowSeller: _followSeller.submitFollowSeller,
        submitUnfollowSeller: _followSeller.submitUnfollowSeller
    }, dispatch);
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
    (0, _inherits3.default)(FollowSellerContainer, _Component);

    function FollowSellerContainer() {
        var _ref2;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FollowSellerContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = FollowSellerContainer.__proto__ || (0, _getPrototypeOf2.default)(FollowSellerContainer)).call.apply(_ref2, [this].concat(args))), _this), _this.toggleFollowSeller = function () {
            if (!_this.props.followed) {
                _this.props.submitFollowSeller(_this.props.sellerId);
            } else {
                _this.props.submitUnfollowSeller(_this.props.sellerId);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FollowSellerContainer, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['button', 'children', 'followed', 'sellerId']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                button = _props.button,
                children = _props.children,
                followed = _props.followed;


            return (0, _jsx3.default)(_components.ShouldLogInContainer, {
                requireLogin: true,
                runFunction: this.toggleFollowSeller
            }, void 0, button ? (0, _jsx3.default)(_FollowSellerButton2.default, {
                followed: followed
            }, void 0, children) : (0, _jsx3.default)(_FollowSellerLink2.default, {
                followed: followed
            }, void 0, children));
        }
    }]);
    return FollowSellerContainer;
}(_react.Component), _class2.defaultProps = {
    button: false
}, _temp2)) || _class);
exports.default = FollowSellerContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FollowSeller/FollowSellerContainer.js
// module id = 1G/f
// module chunks = 57